//local imports
import { Messenger } from "@app/shared";
import { ToastLevel, ToastMessage } from "@app/components";
import {
  CatalogStateService,
  RefreshFilterMessage,
  ProjectModel,
  SPAProjectCreatedNotification,
  ProjectUpdatedNotification,
} from "@app/catalog";

import {
  ProjectAddedMessage,
  ProjectUpdatedMessage,
} from "@app/catalog-common";

export class ProjectStateHandler {
  public initialize(
    catalogStateService: CatalogStateService,
    messenger: Messenger,
  ) {
    //TODO:DIW:Moving message handling for entities into SRP classes
    messenger.subscribe(
      catalogStateService,
      SPAProjectCreatedNotification,
      (notification: SPAProjectCreatedNotification) => {
        let project = new ProjectModel();

        project.id = notification.projectId;

        project.name.set(notification.projectName);
        project.thumbnailUrl.set(notification.thumbnailUrl);
        project.programId.set(notification.program?.id ?? null);
        project.projectCap.set(notification.cap);
        project.spa.set(notification.spa);

        catalogStateService.CatalogManagementState.projects.set([
          project,
          ...catalogStateService.CatalogManagementState.projects(),
        ]);

        messenger.send(
          ToastMessage.create(
            new ProjectAddedMessage(project),
            ToastLevel.Information,
          ),
        );
        messenger.send(new RefreshFilterMessage());
      },
    );

    // messenger.subscribe(
    //   catalogStateService,
    //   ProjectUpdatedNotification,
    //   (message: ProjectUpdatedNotification) => {
    //     let project =
    //       catalogStateService.CatalogManagementState.projects().find(
    //         (u) => u.id === message.projectId,
    //       );

    //     if (!project) {
    //       project = new ProjectModel();
    //       project.id = message.projectId;

    //       project.name.set(message.projectName);
    //     }

    //     this.updateProject(project, message);

    //     messenger.send(new RefreshFilterMessage());
    //     messenger.send(
    //       ToastMessage.create(
    //         new ProjectUpdatedMessage(project),
    //         ToastLevel.Information,
    //       ),
    //     );
    //   },
    // );

    // // Subscribing to the backend notifications for project added.
    // // This is where you can handle the notification and update the UI accordingly.
    // messenger.subscribe(
    //   catalogStateService,
    //   ProjectAddedNotification,
    //   (notification: ProjectAddedNotification) => {
    //     console.log("ProjectAddedNotification received:", notification);

    //     // Todo:SS: update the project carousel with the new project
    //     // Todo:SS: show a toast message that the project was added successfully
    //   },
    // );

    // // Subscribing to the backend notifications for project updated.
    // // This is where you can handle the notification and update the UI accordingly.
    // messenger.subscribe(
    //   catalogStateService,
    //   ProjectUpdatedNotification,
    //   (notification: ProjectUpdatedNotification) => {
    //     console.log("ProjectUpdatedNotification received:", notification);

    //     // Todo:SS: update the project carousel with the new project
    //     // Todo:SS: show a toast message that the project was updated successfully
    //   },
    // );
  }

  // private updateProject(
  //   project: ProjectModel,
  //   message: SPAProjectCreatedNotification | ProjectUpdatedNotification,
  // ) {
  //   //TODO:DIW:Move into it's own class..
  //   //TODO:DIW:Set properties by reading changed properties collection and mapping..

  //   for (let change of message.changes) {
  //     if (change.propertyName.toLowerCase() === "name") {
  //       project.name.set(change.newValue);
  //     }
  //   }
  // }
}
